import { useState } from 'react';
import { Trash2 } from 'lucide-react';

interface ProfitModalProps {
  onAdd: (transaction: { amount: string; client: string; destination: string; date: string }) => void;
  onDelete: (id: string) => void;
  onClose: () => void;
  transactions: any[];
  isDark: boolean;
}

export default function ProfitModal({ onAdd, onDelete, onClose, transactions, isDark }: ProfitModalProps) {
  const [amount, setAmount] = useState('');
  const [client, setClient] = useState('');
  const [destination, setDestination] = useState('');

  const formatNumber = (num: number) => {
    if (num === undefined || num === null || isNaN(num)) return '0';
    return Number(num).toLocaleString('ru-RU');
  };

  const handleSubmit = () => {
    if (amount && client) {
      onAdd({
        amount,
        client,
        destination,
        date: new Date().toISOString()
      });
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm">
      <div className={`w-full max-w-lg rounded-3xl p-8 shadow-2xl ${isDark ? 'bg-slate-800 text-white border border-slate-700' : 'bg-white'}`}>
        <h3 className="text-xl font-bold mb-4">Калькулятор прибыли</h3>
        
        <div className="space-y-3 mb-6">
          <input
            className={`w-full p-3 rounded-xl focus:outline-none border ${isDark ? 'bg-slate-900 border-slate-700 text-white' : 'bg-slate-50 border-slate-200'}`}
            placeholder="Клиент"
            value={client}
            onChange={(e) => setClient(e.target.value)}
          />
          <input
            className={`w-full p-3 rounded-xl focus:outline-none border ${isDark ? 'bg-slate-900 border-slate-700 text-white' : 'bg-slate-50 border-slate-200'}`}
            type="number"
            placeholder="Сумма"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
          />
          <input
            className={`w-full p-3 rounded-xl focus:outline-none border ${isDark ? 'bg-slate-900 border-slate-700 text-white' : 'bg-slate-50 border-slate-200'}`}
            placeholder="Направление"
            value={destination}
            onChange={(e) => setDestination(e.target.value)}
          />
        </div>

        <div className="mb-4 max-h-40 overflow-y-auto text-xs text-slate-500 border-t pt-2 custom-scroll">
          <p className="font-bold mb-2 uppercase">История</p>
          {transactions.length === 0 && <p className="text-center italic opacity-50 py-2">История пуста</p>}
          {transactions.slice(0, 5).map((t) => (
            <div key={t.id} className="flex justify-between py-1 items-center group">
              <span>{t.note?.split(' - ')[0] || 'Клиент'}</span>
              <div className="flex items-center gap-2">
                <span>{formatNumber(t.amount)}р</span>
                <button
                  type="button"
                  onClick={() => onDelete(t.id)}
                  className="text-red-400 hover:text-red-600 opacity-0 group-hover:opacity-100 transition-opacity p-1"
                >
                  <Trash2 size={14} />
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="flex gap-2 justify-center">
          <button
            onClick={onClose}
            className="text-slate-500 px-6 py-2 font-bold"
          >
            Отмена
          </button>
          <button
            onClick={handleSubmit}
            className="bg-blue-600 text-white px-6 py-2 rounded-xl font-bold hover:bg-blue-700 transition-colors"
          >
            Добавить
          </button>
        </div>
      </div>
    </div>
  );
}
